import { useCallback, useEffect, useRef, useState } from 'react'
import { makeAccessApi } from 'services/accessService'
import { countVisibleUsers } from 'features/accessControl/visibleUsers'

export const useAccessCount = (scopeType, scopeId, enabled = true, currentUserId = null) => {
  const currentUserRef = useRef(currentUserId)
  currentUserRef.current = currentUserId
  const [count, setCount] = useState(null)
  const versionRef = useRef(0)

  useEffect(() => {
    if (!scopeId || !enabled) {
      setCount(null)
      return undefined
    }
    let cancelled = false
    const version = ++versionRef.current
    const stale = () => cancelled || version !== versionRef.current
    makeAccessApi(scopeType, scopeId).listUsers()
      .then(res => { if (!stale()) setCount(countVisibleUsers(res?.data?.data || [], currentUserRef.current)) })
      .catch(() => { if (!stale()) setCount(null) })
    return () => { cancelled = true }
  }, [scopeType, scopeId, enabled])

  const updateFromUsers = useCallback(users => {
    versionRef.current += 1
    setCount(Array.isArray(users) ? countVisibleUsers(users, currentUserRef.current) : null)
  }, [])

  return [count, updateFromUsers]
}
